exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block{\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    border:1px solid #e0e2e4;\r\n    display: block;\r\n    height: 100%;\r\n    padding: 35px;\r\n}\r\n.author-thumb img {\r\n    height: 100%;\r\n    width: 13%;\r\n}\r\n@media only screen and (max-width:768px){\r\n      .nextButton{\r\n    \r\n      margin-bottom: 85px !important;\r\n      }\r\n  }\r\n.btn:hover{\r\n      opacity: 3;\r\n      color:#fff;\r\n  }\r\n.btn{\r\n      margin-bottom: 0px;\r\n      padding: .1rem 0.75rem;\r\n      border:0px;\r\n      border-radius:0rem; \r\n  }\r\n.bnt-light{\r\n      background-color: #4A2B73;\r\n      border-color:#4A2B73;\r\n  }\r\n.previous {\r\n    background-color: #f1f1f1;\r\n    color: black;\r\n  }\r\n.next {\r\n    background-color: #4CAF50;\r\n    color: white;\r\n  }\r\n.round {\r\n    border-radius: 50%;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/brands/brands.component.css
// module id = ../../../../../src/app/brands/brands.component.css
// module chunks = main